import React, { forwardRef } from 'react';

import useFormikConnection, { TouchTrigger, WithoutInjectedProps } from '../hooks/useFormikConnection';
import NumberFormatInput, { NumberFormatInputProps } from '../../raw/NumberFormatInput';

export interface FormikNumberFormatInputProps extends WithoutInjectedProps<NumberFormatInputProps, 'onChange'> {
  name: string;
  touchedTrigger?: TouchTrigger;
}

const FormikNumberFormatInput = forwardRef<HTMLInputElement, FormikNumberFormatInputProps>(
  ({ name, ...props }, ref) => {
    const { setValue, ...other } = useFormikConnection<number | undefined, HTMLInputElement>(name, props);

    return <NumberFormatInput {...props} {...other} name={name} ref={ref} label={props.label} onChange={setValue} />;
  },
);

export default FormikNumberFormatInput;
